import { getSenderId, getSenderType, getSenderKey
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { VISITOR as VISITOR_SENDER } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { UTK } from 'conversations-message-history/common-message-format/constants/senderIdKeys';
import SenderAvatar from '../avatar/SenderAvatar';
import { AGENT, VISITOR } from 'conversations-message-history/constants/messageUses';
// @ts-expect-error module not typed
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
// @ts-expect-error module not typed
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
// @ts-expect-error module not typed
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
// @ts-expect-error module not typed
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
// @ts-expect-error module not typed
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
// @ts-expect-error module not typed
import TypingHeaderContent from './TypingHeaderContent';
import TypingDots from './TypingDots';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "TypingIndicator__StyledDiv",
  componentId: "sc-3qn3dp-0"
})(["display:flex;align-items:center;flex-direction:column;width:100%;padding:8px;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "TypingIndicator__StyledContentColumn",
  componentId: "sc-3qn3dp-1"
})(["display:flex;flex-direction:row;"]);
const TypingIndicator = ({
  message,
  onClickAvatar,
  positionDescriptors,
  senderName,
  senders,
  vid
}) => {
  const senderId = getSenderKey(message) === UTK ? vid : getSenderId(message);
  const senderType = getSenderType(message);
  const isFromVisitor = getSenderType(message) === VISITOR_SENDER;
  const asyncSender = findSender(senderId, senderType, senders);
  const sender = getData(asyncSender);
  const isLoading = isSenderLoading(asyncSender);
  const use = isFromVisitor ? VISITOR : AGENT;
  return /*#__PURE__*/_jsx(PrimaryMessage, {
    positionDescriptors: positionDescriptors,
    use: use,
    children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsxs(StyledContentColumn, {
        children: [/*#__PURE__*/_jsx(PrimaryMessageAvatar, {
          children: /*#__PURE__*/_jsx(SenderAvatar, {
            onClick: onClickAvatar,
            sender: sender,
            use: use,
            isLoading: isLoading,
            size: 'sm'
          })
        }), /*#__PURE__*/_jsxs(StyledDiv, {
          children: [/*#__PURE__*/_jsx(PrimaryMessageHeaderContent, {
            children: /*#__PURE__*/_jsx(TypingHeaderContent, {
              message: message,
              sender: sender,
              senderName: senderName,
              isSenderLoading: isLoading
            })
          }), /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
            children: /*#__PURE__*/_jsx(TypingDots, {})
          })]
        })]
      })
    })
  });
};
TypingIndicator.displayName = 'TypingIndicator';
export default TypingIndicator;